<template>
    <button class="button nice gap-2" @click="tryFBlogin">{{ $t('INBOX_MGMT.FACEBOOK_REAUTHORIZE.REAUTHORIZE_OPTIONAL_BUTTON') }}</button>
  </template>
  
  <script>

import { useAlert } from 'dashboard/composables';
  /* global FB */
  export default {
    props: {
      inbox: {
        type: Object,
        required: true,
      },
    },
    computed: {
      inboxId() {
        return this.inbox.id;
      },
    },
    mounted() {
      this.initFB();
      this.loadFBsdk();
    },
    methods: {
      initFB() {
        if (window.fbSDKLoaded === undefined) {
          window.fbAsyncInit = () => {
            FB.init({
              appId: window.chatwootConfig.fbAppId,
              xfbml: true,
              version: window.chatwootConfig.fbApiVersion,
              status: true,
            });
            window.fbSDKLoaded = true;
            FB.AppEvents.logPageView();
          };
        }
      },
  
      loadFBsdk() {
        ((d, s, id) => {
          let js;
          // eslint-disable-next-line
          const fjs = (js = d.getElementsByTagName(s)[0]);
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = 'https://connect.facebook.net/en_US/sdk.js';
          fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
      },
  
      tryFBlogin() {
        FB.login(
          response => {
            if (response.status === 'connected') {
              this.reauthorizeFBPage(response.authResponse.accessToken);
            } else if (response.status === 'not_authorized') {
              // The person is logged into Facebook, but not your app.
              useAlert(this.$t('INBOX_MGMT.DETAILS.ERROR_FB_AUTH'));
            } else {
              // The person is not logged into Facebook, so we're not sure if
              // they are logged into this app or not.
              useAlert(this.$t('INBOX_MGMT.DETAILS.ERROR_FB_AUTH'));
            }
          },
          {
            scope:
              'pages_manage_metadata,pages_messaging,instagram_basic,pages_show_list,pages_read_engagement,instagram_manage_messages,pages_manage_engagement,pages_read_user_content,public_profile,business_management',
            auth_type: 'reauthorize',
          }
        );
      },
      async reauthorizeFBPage(omniauthToken) {
        try {
          await this.$store.dispatch('inboxes/reauthorizeFacebookPage', {
            omniauthToken,
            inboxId: this.inboxId,
          });
          useAlert(
            this.$t('INBOX_MGMT.FACEBOOK_REAUTHORIZE.MESSAGE_SUCCESS')
          );
        } catch (error) {
          useAlert(
            this.$t('INBOX_MGMT.FACEBOOK_REAUTHORIZE.MESSAGE_ERROR')
          );
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import 'widget/assets/scss/variables.scss';
  
  .fb--login {
    img {
      max-width: 240px;
      padding: $space-normal 0;
    }
  }
  </style>
